import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class SendMessage extends Performer<
  {
    urlParams: {
      id: number
    }
    payload: {
      message: string
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/chatters/{id}/send-message'
}

export default new SendMessage().perform
